/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { colors } from '@veeam/components/lib/themes/colors/colors';
import * as constants from '@veeam/components/lib/helpers/constants';

export const BoldText = styled.span`
  color: ${colors.G600};
  font-weight: ${constants.BASE_FONT_BOLD_WEIGHT};
`;
